import { CheckCircle2, Heart, Minus, Plus, ShoppingCart, Truck } from "lucide-react";
import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { ProductCard } from "../../components/commerce/ProductCard";
import { formatVnd, products } from "../../data/products";

export function ProductPage() {
  const { slug } = useParams();
  const product = useMemo(
    () => products.find((item) => item.slug === slug) ?? products[0],
    [slug]
  );
  const [quantity, setQuantity] = useState(1);

  return (
    <main className="page-canvas">
      <section className="container product-detail">
        <div className="product-gallery">
          <div className="product-main-art">
            <span>{product.category}</span>
            <strong>{product.name}</strong>
          </div>
          <div className="thumb-row">
            {["Ảnh chính", "Tem SKU", "Thông số", "Lắp đặt"].map((label) => (
              <button key={label} type="button">
                {label}
              </button>
            ))}
          </div>
        </div>
        <div className="product-info">
          <div className="product-badges">
            {product.badges.map((badge) => (
              <span key={badge}>{badge}</span>
            ))}
          </div>
          <h1>{product.name}</h1>
          <p className="product-lede">
            Kiểm tra tương thích trước khi giao, lưu lịch sử bảo hành và hỗ trợ sourcing mã thay thế.
          </p>
          <div className="detail-price">
            <strong>{formatVnd(product.price)}</strong>
            {product.originalPrice ? <s>{formatVnd(product.originalPrice)}</s> : null}
          </div>
          <div className="fitment-box">
            <h2>Tương thích</h2>
            <div>
              {product.fitment.map((fitment) => (
                <span key={fitment}>{fitment}</span>
              ))}
            </div>
          </div>
          <div className="spec-grid">
            {Object.entries(product.specs).map(([key, value]) => (
              <div key={key}>
                <span>{key}</span>
                <strong>{value}</strong>
              </div>
            ))}
          </div>
          <div className="buy-box">
            <div className="qty">
              <button type="button" onClick={() => setQuantity((value) => Math.max(1, value - 1))}>
                <Minus aria-hidden="true" />
              </button>
              <strong>{quantity}</strong>
              <button type="button" onClick={() => setQuantity((value) => value + 1)}>
                <Plus aria-hidden="true" />
              </button>
            </div>
            <button className="btn btn-primary" type="button">
              <ShoppingCart aria-hidden="true" />
              <span>Thêm vào giỏ</span>
            </button>
            <button className="btn btn-secondary-light" type="button">
              <Heart aria-hidden="true" />
              <span>Yêu thích</span>
            </button>
          </div>
          <div className="service-row">
            <span>
              <CheckCircle2 aria-hidden="true" /> Đúng mã trước khi giao
            </span>
            <span>
              <Truck aria-hidden="true" /> Theo dõi đơn hàng
            </span>
          </div>
        </div>
      </section>
      <section className="container section related-section">
        <div className="section-head">
          <div>
            <h2>Sản phẩm liên quan</h2>
            <p>Gợi ý dựa trên nhóm hàng và tương thích.</p>
          </div>
        </div>
        <div className="product-grid">
          {products
            .filter((item) => item.id !== product.id)
            .slice(0, 4)
            .map((item) => (
              <ProductCard key={item.id} product={item} compact />
            ))}
        </div>
      </section>
    </main>
  );
}
